import { GET, POST, PUT } from "@store/methods";

// products
export const fetchProducts = (params) => {
  return GET("/fetch-products", params);
};

// section products
export const fetchSectionProducts = (params) => {
  return GET("/fetch-section-products", params);
};

// section months
export const fetchSectionMonths = (params) => {
  return GET("/fetch-section-months", params);
};

//fetch calender month
export const fetchCalenderMonths = (params) => {
  return GET("/get-calender-months", params);
};

//fetch companies
export const fetchCompanies = (params) => {
  return GET("/companies", params);
};

//fetch countries
export const fetchCountries = (params) => {
  return GET("/countries", params);
};

//fetch years
export const fetchYears = (params) => {
  return GET("/get-years-list", params);
};

//fetch users
export const fetchUsers = (params) => {
  return GET("/get-users", params);
};

// create user
export const createUser = (data, params) => {
  return POST("/create-user", data, params);
};

// edit user
export const editUser = (data, params) => {
  return POST("/edit-user", data, params);
};

//fetch substypes
export const fetchSubtypes = (params) => {
  return GET("/types-and-sub-types", params);
};

//fetch imports and exports
export const fetchImportAndExportData = (params) => {
  return GET("/get-imports-and-exports", params);
};

//update imports and exports
export const updateImportAndExportData = (data, params) => {
  return PUT("/update-imports-and-exports", data, params);
};
